import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LEGAL_ROUTES } from "@/shared/constants/paths";

// Legal Pages
import PrivacyPolicyPage from "@/pages/legal/privacy-policy/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/legal/terms-of-service/TermsOfServicePage";

export const legalRoutes = (
  <>
    <Route
      path={LEGAL_ROUTES.PRIVACY_POLICY}
      element={
        <>
          <Helmet>
            <title>Privacy Policy - Elayne</title>
          </Helmet>
          <PrivacyPolicyPage />
        </>
      }
    />
    <Route
      path={LEGAL_ROUTES.TERMS_OF_SERVICE}
      element={
        <>
          <Helmet>
            <title>Terms of Service - Elayne</title>
          </Helmet>
          <TermsOfServicePage />
        </>
      }
    />
  </>
);
